<template>
	<AppCard title="Verkoop" card-id="verkoop" :collapsible="true">
		<SchemaForm :schema="state.verkoopSchema" class="page-form" />
	</AppCard>
</template>

<script setup lang="ts">
import { toRef } from "vue";
import useKlantgegevens from "@/store/financiering/tabs/useKlantgegevens";
import { SchemaForm, useSchemaForm } from "formvuelate";
import { storeToRefs } from "pinia";
import { toReactive } from "@vueuse/core";

const klantgegevensStore = useKlantgegevens();
const { state } = storeToRefs(klantgegevensStore);

const values = toReactive(toRef(state.value, "values"));
useSchemaForm(values);
</script>
